import { SET_ERROR, RESET } from "../types/errors";

const setError = (errorMessage) => ({ type: SET_ERROR, errorMessage });

const reset = () => ({ type: RESET });

export { setError, reset };
export default { setError, reset };
